import { useLayoutEffect } from "react";
import type { SiteTheme, SiteTokens } from "~/theme/types";

const TOKEN_TO_CSS_VAR: Record<keyof SiteTokens, string> = {
  primary: "--ip-primary",
  primarySoft: "--ip-primary-soft",
  primaryHover: "--ip-primary-hover",
  primaryGlow: "--ip-primary-glow",
  bg: "--ip-bg",
  surface: "--ip-surface",
  text: "--ip-text",
  textBody: "--ip-text-body",
  textMuted: "--ip-text-muted",
};

export function useIpTheme(theme: SiteTheme) {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const slugClass = `theme-${theme.slug}`;
    const isIp = theme.slug !== "home";
    if (isIp) root.classList.add("theme-ip");
    root.classList.add(slugClass);

    for (const [key, cssVar] of Object.entries(TOKEN_TO_CSS_VAR) as [keyof SiteTokens, string][]) {
      root.style.setProperty(cssVar, theme.tokens[key]);
    }

    return () => {
      if (isIp) root.classList.remove("theme-ip");
      root.classList.remove(slugClass);
      for (const cssVar of Object.values(TOKEN_TO_CSS_VAR)) {
        root.style.removeProperty(cssVar);
      }
    };
  }, [theme]);
}
